import React from 'react';

import i18next from 'i18next';
import { SingleCheckbox } from '@sogei/react-web-components-catalog'





class SceltaRicercaAvvisi extends React.Component {

  constructor(props) {
    super(props);
    
}

  

  componentDidMount() {
  }

 

  render() {

    const sRicercaAvvisi = (props) => {
       
      //console.log("this.values: ", JSON.stringify(this.values));
      

      //console.log("props: ", JSON.stringify(props));
      return (

        props.tipoPratica == 'UN' ?
        <div className='row'>
        <div className='col-sm-12 col-md-6 col-xl-6 pb-5'>
        <SingleCheckbox
        id={"flagAvvisi"}
        name={"flagAvvisi"}
        label={i18next.t("FLAG_AVVISI")}
        dimension={"sm"}
        event={{ onChange: (event) => {
          props.values.setFieldValue('flagAvvisi',event.target.checked);
          
        } }}
        extraProps={ { visible: true, checked: props.values.values.flagAvvisi }}
       ></SingleCheckbox>
       </div>
       </div>
          : null

      )

    }

    return (
      sRicercaAvvisi(this.props)

    );
  }

}


const defaultRicercaAvvisi = () => {
   
  return false
}  

//export default SceltaRicercaAvvisi;

export {SceltaRicercaAvvisi, defaultRicercaAvvisi};